import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

function Loader() {
  return (
    <div className="flex min-h-screen items-center justify-center" style={{ backgroundColor: "#0b0a1f", backgroundImage: "radial-gradient(50% 50% at 20% 15%, rgba(37,99,235,.5), transparent 60%), radial-gradient(50% 50% at 85% 20%, rgba(124,58,237,.5), transparent 60%), radial-gradient(60% 50% at 60% 100%, rgba(219,39,119,.3), transparent 60%)" }}>
      <div className="flex flex-col items-center gap-4">
        <div className="floaty [filter:drop-shadow(0_0_10px_rgba(124,110,255,0.6))]"><Logo variant="lg" /></div>
        <p className="shimmer-text text-sm font-semibold">Loading Suffle…</p>
      </div>
    </div>
  );
}

const HOME_BY_ROLE = { customer: "/app/home", travel_agent: "/seller/home", super_admin: "/admin", support_agent: "/support-console", pending: "/choose-role" };

export default function ProtectedRoute({ roles, children }) {
  const { user, booting } = useAuth();
  const location = useLocation();
  if (booting || user === undefined) return <Loader />;
  if (user === null) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.role === "pending") return <Navigate to="/choose-role" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={HOME_BY_ROLE[user.role] || "/login"} replace />;
  return children;
}

export { HOME_BY_ROLE };
